import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader.tsx";
import { lazy, Suspense } from "react";

const StressHistoryPage = lazy(() => import("./StressHistoryPage.tsx"));

function StressHistoryPageLazy() {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <StressHistoryPage />
    </Suspense>
  );
}

export default StressHistoryPageLazy;
